import { MONGO_FILTER_OPERATORS } from '@vy/types';
import type { FilterField, FilterLineType } from '../../../../components/new-design/vyTableFilter';
import {
  MULTISELECT_OPERATORS,
  TEXT_OPERATORS,
} from '../../reports-components/shared-filter-fields/filter-field-builders';
import type { JournalEntryRow } from './flatten-journal-entries';
import { ACCOUNT_LABELS } from './format-journal-entry-account';

const NUMERIC_OPERATORS: FilterField['operators'] = [
  { label: 'Equals', value: MONGO_FILTER_OPERATORS.EQUALS },
  { label: 'Greater than', value: MONGO_FILTER_OPERATORS.GREATER_THAN },
  { label: 'Less than', value: MONGO_FILTER_OPERATORS.LESS_THAN },
  { label: 'Greater than or equal', value: MONGO_FILTER_OPERATORS.GREATER_THAN_OR_EQUAL },
  { label: 'Less than or equal', value: MONGO_FILTER_OPERATORS.LESS_THAN_OR_EQUAL },
];

const ACCOUNT_OPTIONS = Object.entries(ACCOUNT_LABELS).map(([value, label]) => ({ value, label }));

export const JOURNAL_ENTRIES_FILTER_FIELDS: FilterField[] = [
  { id: 'description', label: 'Description', inputType: 'text', operators: TEXT_OPERATORS },
  {
    id: 'account',
    label: 'Account',
    inputType: 'select',
    operators: MULTISELECT_OPERATORS,
    options: ACCOUNT_OPTIONS,
  },
  { id: 'debit', label: 'Debit', inputType: 'number', operators: NUMERIC_OPERATORS },
  { id: 'credit', label: 'Credit', inputType: 'number', operators: NUMERIC_OPERATORS },
];

export function matchesJournalEntryFilter(row: JournalEntryRow, filter: FilterLineType): boolean {
  if (filter.field === 'description') {
    const search = String(filter.value ?? '').trim().toLowerCase();
    if (!search) return true;
    return row.description.toLowerCase().includes(search);
  }

  if (filter.field === 'account') {
    const selected = Array.isArray(filter.value) ? filter.value.map(String) : [];
    if (selected.length === 0) return true;
    const isIncluded = selected.includes(row.account);
    return filter.operator === MONGO_FILTER_OPERATORS.NOT_IN ? !isIncluded : isIncluded;
  }

  if (filter.field !== 'debit' && filter.field !== 'credit') return true;
  const rowValue = row[filter.field];
  const filterValue = Number(filter.value);
  if (Number.isNaN(filterValue)) return true;

  switch (filter.operator) {
    case MONGO_FILTER_OPERATORS.EQUALS:
      return rowValue === filterValue;
    case MONGO_FILTER_OPERATORS.GREATER_THAN:
      return rowValue > filterValue;
    case MONGO_FILTER_OPERATORS.GREATER_THAN_OR_EQUAL:
      return rowValue >= filterValue;
    case MONGO_FILTER_OPERATORS.LESS_THAN:
      return rowValue < filterValue;
    case MONGO_FILTER_OPERATORS.LESS_THAN_OR_EQUAL:
      return rowValue <= filterValue;
    default:
      return true;
  }
}
